export var DEFAULT_CONFIG={enableAirPlay:!1,filterSafariUnknownCc:!0,refetchMasterPlaylist:!0};